"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonControl = void 0;
var _Fab2 = _interopRequireDefault(require("@mui/material/Fab"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _client = require("react-dom/client");
var _styledComponents = require("styled-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ButtonControl {
  constructor(id, options, callback) {
    this.id = id;
    this.options = options;
    this.callback = callback;
  }
  onAdd(_map) {
    this.map = _map;
    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl';
    const content = document.createElement('div');
    content.id = this.id;
    this.container.appendChild(content);
    this.root = (0, _client.createRoot)(this.container);
    return this.container;
  }
  init(theme, options = {}) {
    this.theme = theme;
    this.update(options);
  }
  update(options = {}, callback) {
    if (!this.theme) return;
    const {
      ariaControls,
      ariaHasPopup,
      title,
      tooltipPlacement,
      color,
      icon,
      size,
      variant
    } = this.options = {
      ...this.options,
      ...options
    };
    if (callback) this.callback = callback;
    if (!this.root) return;
    this.root.render(/*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
      theme: this.theme
    }, /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
      theme: this.theme
    }, variant === 'extended' ? /*#__PURE__*/_react.default.createElement(StyledFab, {
      "aria-controls": ariaControls,
      "aria-haspopup": ariaHasPopup,
      color: color,
      onClick: event => this.map ? this.callback(this.map, event) : undefined,
      size: size || 'small',
      style: {
        textTransform: 'initial'
      },
      variant: "extended"
    }, icon, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        marginLeft: 8
      }
    }, title)) : /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
      placement: tooltipPlacement || 'left',
      title: title
    }, /*#__PURE__*/_react.default.createElement(StyledFab, {
      "aria-controls": ariaControls,
      "aria-haspopup": ariaHasPopup,
      "aria-label": title,
      color: color,
      onClick: event => this.map ? this.callback(this.map, event) : undefined,
      size: size || 'small'
    }, icon)))));
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container);
    this.map = undefined;
  }
}
exports.ButtonControl = ButtonControl;
const StyledFab = (0, _styledComponents.styled)(_Fab2.default)`
  && {
    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary) {
      background-color: #fff;
    }

    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary):hover {
      background-color: #d5d5d5;
    }

    &.MuiFab-primary:hover {
      background-color: ${({
  theme
}) => theme.palette.primary.dark};
    }

    &.MuiFab-secondary:hover {
      background-color: ${({
  theme
}) => theme.palette.secondary.dark};
    }
  }
`;